"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerIframeProductWidget = void 0;
var workspaceUrls_1 = require("./workspaceUrls");
function getIframe(widgetElement) {
    return widgetElement.querySelector(".content-frame");
}
function isValidUrl(locationUrl, defaultUrl) {
    var url = new URL(locationUrl);
    var defaultURL = new URL(defaultUrl);
    if (url.hostname !== defaultURL.hostname) {
        return false;
    }
    else {
        return true;
    }
}
function navigateIFrame(iframe, url, settings, instanceId) {
    var iframeUrl = new URL(url);
    var iframeOrigin = iframeUrl.origin;
    iframe.addEventListener("load", function loadIframe() {
        if (iframe.contentWindow) {
            iframe.contentWindow.postMessage({
                type: "pidgetload",
                widget: {
                    instanceId: instanceId,
                    settings: __assign(__assign({}, settings), { identityUrl: workspaceUrls_1.mapWorkspaceToIdentity(window.location.origin), workspaceUrl: window.location.origin })
                }
            }, iframeOrigin);
        }
        iframe.removeEventListener("load", loadIframe);
    });
    iframe.src = url;
}
function navigate(iframe, url, defaultUrl, settings, instanceId) {
    if (isValidUrl(url, defaultUrl)) {
        navigateIFrame(iframe, url, settings, instanceId);
    }
    else {
        navigateIFrame(iframe, defaultUrl, settings, instanceId);
    }
}
function registerIframeProductWidget(props) {
    WidgetFramework.WidgetManager.registerProductWidget(function (widget) {
        var iframe = getIframe(widget.element);
        if (iframe) {
            widget.configureFrame(iframe);
            // when registered naviagte to the correct url
            if (widget.locationUri) {
                // we have a saved deep link so just navigate
                navigate(iframe, widget.locationUri, widget.settings.defaultUrl, widget.settings, widget.instanceId);
            }
            else {
                // otherwise this is a first load so we need the app
                // to tell use the correct url to navigate to
                props.load({ settings: widget.settings, instanceId: widget.instanceId }).then(function (loadProps) {
                    if (loadProps.url && loadProps.defaultUrl) {
                        navigate(iframe, loadProps.url, loadProps.defaultUrl, widget.settings, widget.instanceId);
                    }
                    else {
                        widget.logError("no url provided to load");
                    }
                });
            }
            widget.onFrameMessage = function (message) {
                if (!message)
                    return;
                switch (message.type) {
                    case "LocationChanged":
                        widget.setLocation(message.url, message.title);
                        break;
                    case "RequestReauthentication":
                        widget.requestReauthentication(message.url);
                        break;
                    case "ShowLoading":
                        widget.showLoading();
                        break;
                    case "HideLoading":
                        widget.hideLoading();
                        break;
                    default:
                        break;
                }
            };
            widget.onLocationChanged = function (url) {
                navigate(iframe, url, widget.settings.defaultUrl, widget.settings, widget.instanceId);
            };
        }
        else {
            widget.logError("no iframe found");
        }
    });
}
exports.registerIframeProductWidget = registerIframeProductWidget;
